export { default } from './Link';
export { default as LinkNewPage } from './LinkNewPage';
